function getCommunityBarElement() {
    var _a;
    return (_a = document.getElementsByClassName('wds-community-bar')) === null || _a === void 0 ? void 0 : _a[0];
}
export function insertDOMElementBeforeCommunityBar(domElement, communityBarElement) {
    if (!communityBarElement) {
        communityBarElement = getCommunityBarElement();
    }
    communityBarElement === null || communityBarElement === void 0 ? void 0 : communityBarElement.before(domElement);
}
export default function wikiFeaturedQuizPlacementHelper(moduleProps, root, isForced) {
    var _a, _b, _c;
    const tocInsertionElement = document.getElementById('toc');
    const genericInsertionElement = document.querySelector('[data-quiz-anchor]');
    const firstHeaderElement = document.querySelector('#mw-content-text h2');
    const contentInsertionElement = (_b = (_a = document.querySelector('.section-header-label:nth-child(1)')) === null || _a === void 0 ? void 0 : _a.parentElement) !== null && _b !== void 0 ? _b : (_c = document.querySelector('.mw-headline')) === null || _c === void 0 ? void 0 : _c.parentElement;
    // For pages where quiz is inserted by editing page source code.
    if (genericInsertionElement) {
        const insertionPoint = genericInsertionElement;
        insertionPoint.after(root);
        return true;
    }
    // For pages where there is a toc
    // https://marvel.fandom.com/wiki/Loki_Laufeyson_(Earth-616)
    // With disctroscale video - https://zelda.fandom.com/wiki/The_Legend_of_Zelda:_Breath_of_the_Wild
    else if (tocInsertionElement) {
        const insertionPoint = contentInsertionElement;
        insertionPoint.before(root);
        return true;
    }
    // No TOC, no custom insertion. Just insert after first header
    // https://starwars.fandom.com/wiki/Droid_Tales
    else if (firstHeaderElement) {
        const insertionPoint = contentInsertionElement;
        insertionPoint.before(root);
        return true;
    }
    // if we're forcing, just add it to the bottom of the body
    if (isForced) {
        moduleProps.log.error('Quiz forced, but insertion point cannot be found, appending quiz to the body');
        document.body.appendChild(root);
        return true;
    }
    moduleProps.log.error('Error in insertion of quiz due to lack of insertion point on page');
    return false;
}
